import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { userColor } from '../utils/userColor';
import { getInitial } from '../utils/commentAvatar';
// One consistent identity face used across the app: the user's photo when set,
// otherwise their initials on their comment color. Falls back to initials if the
// photo fails to load (e.g. an expired presigned URL).
export const Avatar = ({ userId, commentColor, photoUrl, source, size = 28, border, className, title, style, }) => {
    const [failed, setFailed] = useState(false);
    // A new URL deserves a fresh chance to load.
    useEffect(() => {
        setFailed(false);
    }, [photoUrl]);
    const { fill, fg } = userColor(userId, commentColor);
    const showPhoto = !!photoUrl && !failed;
    return (_jsx("div", { className: className, title: title, style: {
            width: size,
            height: size,
            borderRadius: '50%',
            backgroundColor: fill,
            color: fg,
            fontSize: Math.round(size * 0.45),
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            flexShrink: 0,
            border: border || 'none',
            boxSizing: 'border-box',
            ...style,
        }, children: showPhoto ? (_jsx("img", { src: photoUrl, alt: "", onError: () => setFailed(true), style: { width: '100%', height: '100%', objectFit: 'cover', display: 'block' } })) : (getInitial(source)) }));
};
